import { tag } from '@blotoutio/edgetag-sdk-js';
import { ProductInterface } from '@qlevr/shared/interfaces';
import { getShopifyProductId, replaceProductSlugInUrl } from '@qlevr/shared/utilities';

export function blotoutViewContent(product: ProductInterface): void {
  const activeVariant = product.variants?.[0];

  const content = {
    id: getShopifyProductId(product.id ?? ''),
    quantity: 1,
    item_price: parseFloat(product?.priceRange?.minVariantPrice.amount?.toString() ?? '0.0'),
    title: product.title ?? '',
    category: product.productType ?? '',
    image: product.featuredImage?.lg.url ?? product.featuredImage?.url ?? '',
    url: replaceProductSlugInUrl(window.location.href, activeVariant?.slug ?? ''),
    brand: product.vendor ?? '',
    variantId: getShopifyProductId(activeVariant?.id ?? ''),
    sku: activeVariant?.sku ?? '',
  };

  tag('ViewContent', {
    currency: 'EUR',
    value: parseFloat(product?.priceRange?.minVariantPrice.amount?.toString() ?? '0.0'),
    contents: [content],
  });
}

export default blotoutViewContent;
